import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import toast from '~/utils/toast';

import { type UpgradeHandoff, useUpgradeHandoff } from '../../_hooks/useUpgradeHandoff';

export interface ContentUpgradePurchase {
  name: string;
  pageSlug: string;
  resourceId?: string;
}

export const useContentUpgradeHandoff = (
  isGranted: (purchase: ContentUpgradePurchase) => boolean,
): UpgradeHandoff<ContentUpgradePurchase> => {
  const { t } = useTranslation();
  const onGranted = useCallback(
    ({ name }: ContentUpgradePurchase) => toast.success(t('community.upgrade_modal.content_unlocked', { name })),
    [t],
  );

  return useUpgradeHandoff<ContentUpgradePurchase>({ modalType: 'community_content_upgrade', isGranted, onGranted });
};
